import React, { useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { XMarkIcon, CheckIcon } from '@heroicons/react/24/outline'; // Updated imports
import { updateCompleteStatus } from '../../api/api';
import { updateDispatchStatus } from '../../api/employeeApi';

const ReceiptUploadModal = ({ isOpen, onClose, onSubmit, projectId ,dispatchInfo }) => {
  const [receiptNumber, setReceiptNumber] = useState('');
  const [billCopy, setBillCopy] = useState(null);
  const [billValue, setBillValue] = useState('');
  const [billNo, setBillNo] = useState('');
  const [quantity, setQuantity] = useState('');

  const handleFileChange = (event) => {
    setBillCopy(event.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if(dispatchInfo){
      updateDispatchStatus({...dispatchInfo,newStatus:"completed",projectId, billDetails:{ billValue, billNo, quantity },billCopy})
      .then(res=>{
        toast.success(res.message)
        onClose()
      }).catch(err=>{
        toast.error(err?.response?.data?.message)
      })
    }else{
      updateCompleteStatus(projectId,{ billCopy, billValue, billNo, quantity }).then((res)=>{
        toast.success(`${res.message} status updated successfully`);
        onClose()
        // toast.success('status updated successfully')
      }).catch(err=>console.log(err))
    }
    
    resetForm();
  };

  const resetForm = () => {
    setReceiptNumber('');
    setBillCopy(null);
    setBillValue('');
    setBillNo('');
    setQuantity('');
  };

  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 z-50 flex items-center justify-end bg-black bg-opacity-50"
    >
      <div className="bg-white rounded-lg poppins-regular h-screen shadow-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-bold text-gray-900 mb-6">Before Completing, You Need To Upload Receipt</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium poppins-medium text-gray-700 mb-1">Receipt Number</label>
            <input
              type="text"
              value={billNo}
              onChange={(e) => setBillNo(e.target.value)}
              required
              className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
              placeholder="Enter receipt number"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Receipt Value</label>
            <input
              type="number"
              value={billValue}
              onChange={(e) => setBillValue(e.target.value)}
              required
              className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
              placeholder="Enter receipt value"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Qty</label>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              required
              className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
              placeholder="Enter quantity"
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Upload Bill Copy</label>
            <input
              type="file"
              accept=".pdf,image/*"
              onChange={handleFileChange}
              className="border border-gray-300 rounded-lg p-3 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
            />
          </div>
          <div className="flex w-full mt-4">
            <button
              type="button"
              onClick={onClose}
              className="mr-2 flex items-center bg-gray-300 w-1/2 text-gray-700 rounded-lg px-4 py-2 hover:bg-gray-400 transition duration-200"
            >
              <span className='flex justify-center mx-auto'>
                <XMarkIcon className="h-5 w-5 mr-1" />
                Cancel
              </span>
            </button>
            <button
              type="submit"
              className="flex items-center w-1/2 text-center bg-black text-white rounded-lg px-4 py-2 transition duration-200"
            >
              <span className='flex justify-center mx-auto'>
                <CheckIcon className="h-5 w-5 mr-1" />
                Submit
              </span>
            </button>
          </div>
        </form>
      </div>
    </motion.div>
  );
};

export default ReceiptUploadModal;
